const audio_data = {
    castle: {
        peaceful: { options: [] },
        combat: { options: [] },
        low: { options: [] },
    },
    lake: {
        peaceful: { options: ['shop', 'oboe'] },
        combat: { options: ['shop', 'oboe'] },
        low: { options: ['shop', 'oboe'] }
    },
    mountain: {
        peaceful: { options: ['shop'] },
        combat: { options: ['shop'] },
        low: { options: ['shop'] }
    },
    overworld: {
        peaceful: { options: ['shop'] },
        combat: { options: ['shop'] },
        low: { options: ['shop'] }
    },
    ruins: {
        peaceful: { options: ['shop', 'bass'] },
        combat: { options: ['shop', 'bass'] },
        low: { options: ['shop', 'bass'] }
    },
    swamp: {
        peaceful: { options: ['shop', 'maracas'] },
        combat: { options: ['shop', 'maracas'] },
        low: { options: ['shop', 'maracas'] }
    },
    temple: {
        peaceful: { options: ['shop', 'glockenspiel'] },
        combat: { options: ['shop', 'glockenspiel'] },
        low: { options: ['shop', 'glockenspiel'] }
    },
    valley: {
        peaceful: { options: ['shop'] },
        combat: { options: ['shop'] },
        low: { options: ['shop'] }
    },
    village: {
        peaceful: { options: [] },
        low: { options: [] },
    },
    woods: {
        peaceful: { options: ['shop'] },
        combat: { options: ['shop'] },
        low: { options: ['shop'] }
    }
}

export default audio_data;